module.exports = __webpack_public_path__ + "static/media/IC_Help.a8a3375b.svg";